import { render, staticRenderFns } from "./elEmpty.vue?vue&type=template&id=a1de6708&scoped=true"
import script from "./elEmpty.vue?vue&type=script&lang=js"
export * from "./elEmpty.vue?vue&type=script&lang=js"
import style0 from "./elEmpty.vue?vue&type=style&index=0&id=a1de6708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1de6708",
  null
  
)

export default component.exports